import { render, staticRenderFns } from "./AllTerminals.vue?vue&type=template&id=4b32ce0e&scoped=true"
import script from "./AllTerminals.vue?vue&type=script&lang=js"
export * from "./AllTerminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32ce0e",
  null
  
)

export default component.exports